export default {
  props: {
    label: { default: '', type: String }, // Label for section
    path: {
      default: () => {
        return {}
      },
      type: Object
    }, // Path to navigator for root of app
    alwaysVisible: { default: false, type: Boolean }, // Always visble or not
    children: {
      default: () => {
        return []
      },
      type: Array
    }, // Child menu items
    data: {
      default: () => {
        return {}
      },
      type: Object
    } // Convenience prop
  },
  computed: {
    dataObj() {
      const keys = Object.keys(this.data)

      return {
        reload: keys.indexOf('reload') > -1 ? this.data.reload : this.reload,
        label: keys.indexOf('label') > -1 ? this.data.label : this.label,
        icon: keys.indexOf('icon') > -1 ? this.data.icon : this.icon,
        iconAdjust:
          keys.indexOf('iconAdjust') > -1
            ? this.data.iconAdjust
            : this.iconAdjust,
        children:
          (keys.indexOf('children') > -1
            ? this.data.children
            : this.children) || [],
        path: keys.indexOf('path') > -1 ? this.data.path : this.path,
        collapsedLabel:
          keys.indexOf('collapsedLabel') > -1
            ? this.data.collapsedLabel
            : this.collapsedLabel,
        alwaysVisible:
          keys.indexOf('alwaysVisible') > -1
            ? this.data.alwaysVisible
            : this.alwaysVisible
      }
    },
    isSelected() {
      if (this.$route.name == this.dataObj.path.name) {
        if (this.dataObj.path.params) {
          return (
            JSON.stringify(this.dataObj.path.params) ==
            JSON.stringify(this.$route.params)
          )
        } else {
          return true
        }
      } else if (
        this.dataObj.path.name == 'FormSearch' &&
        /^FormEdit/.test(this.$route.name)
      ) {
        if (this.dataObj.path.params.formType == this.$route.params.formType) {
          return true
        }
      }
      return this.checkChildSelected(this.dataObj)
    },
    selClass() {
      return {
        selected: this.isSelected
      }
    }
  },
  methods: {
    checkChildSelected(parent) {
      if (parent.children) {
        for (let child of parent.children) {
          if (child.path.name == this.$route.name) {
            if (child.path.params) {
              if (
                JSON.stringify(child.path.params) ==
                JSON.stringify(this.$route.params)
              ) {
                return true
              }
            } else {
              return true
            }
          } else if (
            child.path.name == 'FormSearch' &&
            /^FormEdit/.test(this.$route.name)
          ) {
            if (child.path.params.formType == this.$route.params.formType) {
              return true
            }
          } else if (this.checkChildSelected(child)) {
            return true
          }
        }
      }
      return false
    }
  }
}
